import { useSelector } from "react-redux";
import AvgEngagementTime from "./MetricsCharts/AvgEngagementTime";
import BounceRate from "./MetricsCharts/BounceRate";
import ClickOutRate from "./MetricsCharts/ClickOutRate";
import ScrolledUsers from "./MetricsCharts/ScrolledUsers";
import Sessions from "./MetricsCharts/Sessions";
import { Skeleton } from "@mui/material";

const EngagementMetrics = () => {
  const { pageSpeedMetricsLoading } = useSelector(
    (state: any) => state.landingPageExperience
  );

  const metrics = [
    <Sessions key="sessions" />,
    <BounceRate key="bounce" />,
    <ClickOutRate key="click" />,
    <AvgEngagementTime key="engagement" />,
    <ScrolledUsers key="scroll" />,
  ];

  return (
    <>
      {pageSpeedMetricsLoading
        ? metrics.map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              height={120}
              width="100%"
              sx={{ borderRadius: 2, mb: 2 }}
            />
          ))
        : metrics}
    </>
  );
};

export default EngagementMetrics;
